<script>
  import { getContext } from "svelte";
  import { srcSetFromWidths, sizesForBreakpoints, SRCSET_WIDTHS } from "$lib/utilities";
  import { isExternalUrl } from "$lib/utilities/url-helpers";

  import { GlobalFooter, Link } from "@ObamaFoundation/of-design-system";

  export let footerData;

  let resizeParams = {};

  // Boolean used to ignore the Contentful Image API image resizing logic
  // Introduced to remove chromatic image flakiness caused by small differences in images
  let ignoreContentfulImgResize = getContext("ignoreContentfulImgResize");

  // Image sizes (widths) for available breakpoints.
  // These can be set using any unit, but we recommend using vw (50vw, 100vw, etc.)
  // If you don't set these, the image will be full width at all breakpoints.
  let widthsAt = {};
  const sizes = sizesForBreakpoints(widthsAt);

  const navigationTargetItems = footerData?.children?.filter((i) => i.contentType === "navTarget");

  const footerColumnsRaw = footerData?.children?.filter(
    (i) => i.contentType === "menu" || i.contentType === "linkComponent"
  );

  const parseMenuItem = (menuItem) => {
    const title = menuItem.fields?.trigger?.fields?.text;
    const links = menuItem.children.map((l) => {
      return {
        id: `gtm-${l.url.substring(1, l.url.length - 1).replaceAll("/", "-")}-${l.sys.id}`,
        href: l.url,
        text: l.text,
        isExternal: isExternalUrl(l.url)
      };
    });

    return {
      type: "links",
      title,
      links
    };
  };

  const parseLinkComponentItem = (linkComponent) => {
    return {
      type: "card",
      card: {
        label: linkComponent.text,
        imageUrl: linkComponent.image.fields.file.url,
        srcset: !ignoreContentfulImgResize
          ? srcSetFromWidths(linkComponent.image.fields.file.url, SRCSET_WIDTHS, resizeParams)
          : null,
        sizes,
        alt: linkComponent.image.fields.description,
        linkUrl: linkComponent.destination.fields.url,
        id: `primary-nav-utulity-${linkComponent.sys.id}`
      }
    };
  };

  const footerColumns = footerColumnsRaw.map((c) => {
    if (c.contentType === "linkComponent") {
      return parseLinkComponentItem(c);
    }
    return parseMenuItem(c);
  });

  const donateButtonData = navigationTargetItems.find((i) => i.name === "Donate");

  const footerProps = {
    theme: "cobaltBlue",
    title: "DONATE TODAY",
    subTitle:
      "We need your help to turn hope into action—to inspire, empower, and connect people to change their world.",
    ctaButton: {
      label: donateButtonData.text,
      href: donateButtonData.url,
      id: "footer-donate"
    },
    footerColumns: [...footerColumns],
    socialLinks: [
      { href: "https://www.facebook.com/obamafoundation", iconName: "facebook" },
      { href: "https://www.instagram.com/obamafoundation/?hl=en", iconName: "instagram" },
      { href: "https://www.threads.net/@obamafoundation", iconName: "threads" },
      { href: "https://www.linkedin.com/company/obama-foundation", iconName: "linkedIn" }
    ],
    legalLinks: [
      { href: "/terms-of-service", text: "Terms of service" },
      { href: "/privacy-statement", text: "Privacy policy" }
    ]
  };
</script>

<GlobalFooter {...footerProps}>
  <p slot="bottomText">
    The Obama Foundation is a nonpartisan 501(c)(3) nonprofit organization on a mission to inspire,
    empower, and connect people to change their world.
    <Link
      class="hover:text-white"
      href="/501c3-disclaimer"
      label="Read More"
      variant="inline"
      theme="black"
      isExternal={false}
    />
    &nbsp;about our tax-exempt status.
  </p>
</GlobalFooter>
